import { defineMessages } from 'react-intl';

import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import alignCenterSVG from '@plone/volto/icons/vertical.svg';
import alignStartSVG from '@plone/volto/icons/move-up.svg';

const messages = defineMessages({
  alignItems: {
    id: 'Align items',
    defaultMessage: 'Align items',
  },
  start: {
    id: 'start',
    defaultMessage: 'Start',
  },
  centered: {
    id: 'Centered',
    defaultMessage: 'Centered',
  },
});

export const alignItemsStyleSchema = ({ schema, formData, intl }) => {
  addStyling({ schema, intl });
  schema.properties.styles.schema.fieldsets[0].fields = [
    ...schema.properties.styles.schema.fieldsets[0].fields,
    '--align-items',
  ];
  schema.properties.styles.schema.properties['--align-items'] = {
    title: intl.formatMessage(messages.alignItems),
    widget: 'buttons',
    default: 'center',
    actionsInfoMap: {
      start: [alignStartSVG, intl.formatMessage(messages.start)],
      center: [alignCenterSVG, intl.formatMessage(messages.centered)],
    },
  };
  schema.properties.styles.schema.properties['--align-items'].actions = [
    'center',
    'start',
  ];

  return schema;
};
